import React from 'react';
import { useLocalStore, useObserver } from 'mobx-react';
import BaseballMatchLineupPitcherModel from './model/pitcher';
import BaseballMatchLineupBatterModel from './model/batter';
import { ScoreDetailService } from '../../../../../../common/services';

const BaseballMatchLineupStore = () => {
  const store = useLocalStore(() => ({
    lineup: {
      home: {
        batters: [],
        name: '',
        pitchings: []
      },
      away: {
        batters: [],
        name: '',
        pitchings: []
      }
    },
    loading: true,
    init: false,
    gameId: null,
    selectedTab: 'HOME',
    setSelectedTab(location) {
      store.selectedTab = location;
    },
    get homePitchers() {
      const homeLength = store.lineup.home.pitchings.length;
      const awayLength = store.lineup.away.pitchings.length;

      return {
        list: store.lineup.home.pitchings.sort((a, b) => {
          if (a.sequence > b.sequence) return -1;
          if (a.sequence < b.sequence) return 1;
          else return 0;
        }),
        length: homeLength > awayLength ? homeLength : awayLength
      };
    },
    get awayPitchers() {
      const homeLength = store.lineup.home.pitchings.length;
      const awayLength = store.lineup.away.pitchings.length;

      return {
        list: store.lineup.away.pitchings.sort((a, b) => {
          if (a.sequence > b.sequence) return -1;
          if (a.sequence < b.sequence) return 1;
          else return 0;
        }),
        length: homeLength > awayLength ? homeLength : awayLength
      };
    },
    get homeBatters() {
      const homeLength = store.lineup.home.batters.length;
      const awayLength = store.lineup.away.batters.length;

      return {
        list: store.lineup.home.batters.sort((a, b) => {
          if (a.battingSlot > b.battingSlot) return 1;
          if (a.battingSlot < b.battingSlot) return -1;
          if (a.slotIndex > b.slotIndex) return -1;
          if (a.slotIndex < b.slotIndex) return 1;
          else return 0;
        }),
        length: homeLength > awayLength ? homeLength : awayLength
      };
    },
    get awayBatters() {
      const homeLength = store.lineup.home.batters.length;
      const awayLength = store.lineup.away.batters.length;

      return {
        list: store.lineup.away.batters.sort((a, b) => {
          if (a.battingSlot > b.battingSlot) return 1;
          if (a.battingSlot < b.battingSlot) return -1;
          if (a.slotIndex > b.slotIndex) return -1;
          if (a.slotIndex < b.slotIndex) return 1;
          else return 0;
        }),
        length: homeLength > awayLength ? homeLength : awayLength
      };
    },
    get homeName() {
      return store.lineup.home.name;
    },
    get awayName() {
      return store.lineup.away.name;
    },
    get homeImage() {
      return store.lineup.home.imgPath;
    },
    get awayImage() {
      return store.lineup.away.imgPath;
    },
    get isEmpty() {
      const homePitcherLength = store.lineup.home.pitchings.length;
      const awayPitcherLength = store.lineup.away.pitchings.length;
      const homeBatterLength = store.lineup.home.batters.length;
      const awayBatterLength = store.lineup.away.batters.length;

      return {
        pitcher: homePitcherLength === 0 && awayPitcherLength === 0,
        batter: homeBatterLength === 0 && awayBatterLength === 0
      };
    },
    get getSelectedPitcher() {
      const { isEmpty, selectedTab, lineup } = store;
      let result = [];

      if (!isEmpty.pitcher) {
        result =
          selectedTab === 'HOME'
            ? lineup.home.pitchings
            : lineup.away.pitchings;
      }

      return result;
    },
    get getSelectedBatter() {
      const { isEmpty, selectedTab, lineup } = store;
      let result = [];

      if (!isEmpty.batter) {
        result =
          selectedTab === 'HOME' ? lineup.home.batters : lineup.away.batters;
      }

      return result.sort((a, b) => {
        if (a.battingSlot > b.battingSlot) return 1;
        if (a.battingSlot < b.battingSlot) return -1;
        if (a.slotIndex > b.slotIndex) return -1;
        if (a.slotIndex < b.slotIndex) return 1;
        else return 0;
      });
    },
    async getLineup(gameId) {
      store.loading = true;

      const result = await ScoreDetailService.getLineupBySportsType(
        'baseball',
        gameId
      );

      if (!!result) {
        const deep = result;

        if (result.home.pitchings.length > 0) {
          deep.home.pitchings = result.home.pitchings.map(
            (item) => new BaseballMatchLineupPitcherModel(item, 'home')
          );
        }

        if (result.away.pitchings.length > 0) {
          deep.away.pitchings = result.away.pitchings.map(
            (item) => new BaseballMatchLineupPitcherModel(item, 'home')
          );
        }

        if (result.home.batters.length > 0) {
          deep.home.batters = result.home.batters.map(
            (item) => new BaseballMatchLineupBatterModel(item, 'home')
          );
        }

        if (result.away.batters.length > 0) {
          deep.away.batters = result.away.batters.map(
            (item) => new BaseballMatchLineupBatterModel(item, 'home')
          );
        }

        store.lineup = deep;
        store.loading = false;
      }
    }
  }));

  return {
    getLineup: store.getLineup,
    data: useObserver(() => {
      return {
        init: store.init,
        loading: store.loading,
        homePitchers: store.homePitchers,
        awayPitchers: store.awayPitchers,
        homeBatters: store.homeBatters,
        awayBatters: store.awayBatters,
        homeName: store.homeName,
        awayName: store.awayName,
        homeImage: store.homeImage,
        awayImage: store.awayImage,
        isEmpty: store.isEmpty,
        selectedTab: store.selectedTab,
        setSelectedTab: store.setSelectedTab,
        getSelectedPitcher: store.getSelectedPitcher,
        getSelectedBatter: store.getSelectedBatter
      };
    })
  };
};

export default BaseballMatchLineupStore;
